import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { getGraficosDenuncias } from '../api/informesApi'
import { EVOLUCION_DENUNCIAS_CHART } from '../../../common/constants/charts'
import {
  createEmptyColumnChartResponse,
  mapColumnChartResponse,
  shouldRenderGraficosDenuncias,
} from '../utils/columnCharts'

export const useGraficosDenuncias = (trigger, reportData, contrato) => {
  const [data, setData] = useState(createEmptyColumnChartResponse())
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const shouldRender = shouldRenderGraficosDenuncias(reportData)

  useEffect(() => {
    if (!trigger || !contrato || !reportData?.fechaDesde || !reportData?.fechaHasta) return

    if (!shouldRender) {
      setData(createEmptyColumnChartResponse())
      return
    }

    const controller = new AbortController()

    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const response = await getGraficosDenuncias(contrato, reportData.fechaDesde, reportData.fechaHasta, {
          signal: controller.signal,
        })
        setData(mapColumnChartResponse(response.data, EVOLUCION_DENUNCIAS_CHART))
      } catch (error) {
        if (error.name === 'CanceledError') return
        Sentry.captureException(error)
        setData(createEmptyColumnChartResponse())
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
    return () => controller.abort()
  }, [trigger, contrato, reportData?.fechaDesde, reportData?.fechaHasta, shouldRender])

  return { data, isLoading, error, shouldRender }
}
